module.exports = __webpack_public_path__ + "images/emoji/sushi.f8443216baa71443f1e5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sushi.png
// module id = fU8D
// module chunks = 1